import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to delegate.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>You’ve got a report to write. You could give it to one of your
                                                team members, but it’s easier to do
                                                it yourself. What would you do?</p>


                                            <div className="border_subtitle">Understanding how and when to
                                                delegate
                                            </div>
                                            <div className="paraspace"><p>We’ve all been there, and in practice
                                                many managers find it hard to delegate. Reasons include the
                                                importance of the task or a lack of trust in others to get the
                                                job done. This line of thinking is self-defeating,
                                                as ultimately all tasks are kept on the manager’s to-do list,
                                                adding to their stress and
                                                lessening the likelihood of task completion. In addition, staff
                                                are not stretched by taking on new
                                                tasks, and so their professional development suffers. Fred
                                                Fiedler<a className="superscripttext "
                                                          href="further_info.php?course=300"><sup>1</sup></a> devised
                                                the ‘contingency
                                                theory’ to explain how behaviours should be matched to suit the
                                                team’s characteristics. An
                                                effective leader will be able to predict how well the team
                                                members will respond to varying degrees
                                                of task clarity and understand individual strengths and team
                                                dynamics.</p></div>

                                            <div className="lightgreencontentbg keyquestionpad ">
                                                <div className="border_subtitle">Time and time again</div>
                                                <p className="supLinesapce">One of the most common reasons for
                                                    not delegating is not enough time. An interesting
                                                    recent study into time perceptions was carried out by Ola
                                                    Svenson.<a className="superscripttext "
                                                               href="further_info.php?course=300"><sup>2</sup></a> The
                                                    research looked
                                                    into how long we perceive things to take. Svenson set
                                                    participants a number of mathematical
                                                    tasks, like the two pairs (of a and b) below. Use your
                                                    intuition to decide which option for
                                                    each pair, a or b, will save the most time:</p>
                                                <div className="desktop ilead-model">
                                                    <div className="paraspace"><p><span className="subtiltereg"
                                                                                        style={{paddingRight: '100px'}}><span
                                                        className="brown brownbold">a)</span> Travelling at 50km/h instead of 40km/h.</span><span
                                                        className="subtiltereg"><span
                                                        className="brown brownbold">a)</span> Travelling at 50km/h instead of 30km/h.</span>
                                                    </p></div>
                                                    <p><span className="subtiltereg"
                                                             style={{paddingRight: '94px'}}><span
                                                        className="brown brownbold">b)</span> Travelling at 130km/h instead of 80km/h.</span><span
                                                        className="subtiltereg"><span
                                                        className="brown brownbold">b)</span> Travelling at 130km/h instead of 60km/h.</span>
                                                    </p>
                                                </div>
                                                <div className="mobile ilead-model">
                                                    <div className="paraspace"><p><span
                                                        className="mobile subtiltereg"><span
                                                        className="brown brownbold">a)</span> Travelling at 50km/h instead of 40km/h.</span><span
                                                        className="subtiltereg"><span
                                                        className="brown brownbold">a)</span> Travelling at 50km/h instead of 30km/h.</span>
                                                    </p></div>
                                                    <p><span className="mobile subtiltereg"><span
                                                        className="brown brownbold">b)</span> Travelling at 130km/h instead of 80km/h.</span><span
                                                        className="subtiltereg"><span
                                                        className="brown brownbold">b)</span> Travelling at 130km/h instead of 60km/h.</span>
                                                    </p>
                                                </div>


                                                <p>If you have assumed that option (b) saves the most time then
                                                    you’re like the majority of
                                                    Svenson’s participants. In fact, for the first pair, the
                                                    time saved is roughly equal, and for the
                                                    second pair, option (a) saves more time. If you don’t
                                                    believe us, do the maths on a piece of
                                                    paper; whatever the distance it always works out the
                                                    same!</p>
                                                <div className="uiheading	"><p>This research provides
                                                    evidence for a common error many of us make, which is
                                                    underestimating how long things will take – known as the
                                                    ‘planning fallacy’.</p></div>
                                            </div>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}